import React from 'react';
import { _ } from '../../../functions/translator';

import Checkbox from '@material-ui/core/Checkbox';
import CancelPresentationIcon from '@material-ui/icons/CancelPresentation';
import { AnswersStatus } from '../../../constants/constants';

class ProtocolTable extends React.Component {

    render(){
        const protocolInfo = {
            hasCheck: false,
            hasMeasurement: false
        }
        for (const questionData of Object.values(this.props.protocoltableData.questions)) {
            if (questionData.attributes.has_check) {
                protocolInfo.hasCheck = true;
            }
            if (questionData.attributes.has_measurement) {
                protocolInfo.hasMeasurement = true;
            }
        }
        const isMatrixTable = Object.keys(this.props.protocoltableData.questionoptions).length > 0;
        const tableHeader = [];
        const tableRows = [];
        tableHeader.push(<th></th>);
        if (isMatrixTable) {
            for (const questionData of Object.values(this.props.protocoltableData.questions)) {
                if (this.props.answersInfo.questionIdsWithAnswers.includes(questionData.id)) {
                    tableHeader.push(<th>{questionData.attributes.name}</th>);
                }
            }
            if (protocolInfo.hasCheck) {
                tableHeader.push(<th>{_('Observaciones')}</th>);
            }
            for (const questionoptionData of Object.values(this.props.protocoltableData.questionoptions)) {
                if (!this.props.answersInfo.questionoptionIdsWithAnswers.includes(questionoptionData.id)) continue;
                const row = [<td>{questionoptionData.attributes.name}</td>];
                const observations = [];
                for (const questionData of Object.values(this.props.protocoltableData.questions)) {
                    if (!this.props.answersInfo.questionIdsWithAnswers.includes(questionData.id)) continue;
                    const answerKey = `${questionData.id}_${questionoptionData.id}`;
                    const answerData = this.props.answersInfo.answersDict[answerKey];
                    const tableData = [];
                    if (answerData && questionData.attributes.has_check) {
                        if (answerData.attributes.status == AnswersStatus.NOT_APPLICABLE) {
                            tableData.push(<span style={{marginLeft: '0.75em'}}>N.A.</span>);
                        } else if (answerData.attributes.status == AnswersStatus.ACCEPTED) {
                            tableData.push(<Checkbox checked={true} color="primary" className='checkbox-success py-0' disabled/>);
                        } else if (answerData.attributes.status == AnswersStatus.PENDING) {
                            tableData.push(
                                <div style={{paddingLeft: '12px'}}>
                                    <span class="d-flex align-items-center justify-content-center me-1" 
                                    style={{width: '20px', height: '20px', backgroundColor: '#f55000', color: 'white', borderRadius: '50%'}}>
                                    P
                                    </span>
                                </div>);
                        } else if (answerData.attributes.status == AnswersStatus.OBSERVATION){
                            tableData.push(<Checkbox checked={true} checkedIcon={<CancelPresentationIcon/>} color="primary" className='checkbox-error py-0' disabled/>);
                        } else if (answerData.attributes.status == AnswersStatus.MEASUREMENT_ONLY){
                            tableData.push(<span>-</span>);
                        } else {
                            tableData.push(<span> </span>)
                        }
                    }
                    if (answerData && questionData.attributes.has_measurement) {
                        let measurementValue = '';
                        if (questionData.attributes.measurement_name.length && !answerData.attributes.status == AnswersStatus.NOT_APPLICABLE) {
                            measurementValue = `${questionData.attributes.measurement_name}: `;
                        }
                        if (answerData.attributes.status == AnswersStatus.NOT_APPLICABLE) {
                            measurementValue += 'N.A.';
                        } else {
                            measurementValue += answerData.attributes.measurement;
                        }
                        tableData.push(measurementValue);
                    }
                    if (answerData && answerData.attributes.description.length) {
                        observations.push(`${questionData.attributes.name}: ${answerData.attributes.description}`);
                    }
                    row.push(<td>{tableData}</td>);
                }
                if (protocolInfo.hasCheck) {
                    row.push(<td>{observations.join('\n')}</td>);
                }
                tableRows.push(<tr>{row}</tr>);
            }
        } else {
            if (protocolInfo.hasCheck) {
                tableHeader.push(<th>{_('Estado')}</th>);
            }
            if (protocolInfo.hasCheck) {
                tableHeader.push(<th>{_('Observaciones')}</th>);
            }
            if (protocolInfo.hasMeasurement) {
                tableHeader.push(<th></th>);
            }
            
            for (const questionData of Object.values(this.props.protocoltableData.questions)) {
                console.log("questionData",questionData)
                if (!this.props.answersInfo.questionIdsWithAnswers.includes(questionData.id)) continue;
                const row = [<td>{questionData.attributes.name}</td>];
                const answerData = this.props.answersInfo.answersDict[questionData.id];
                console.log("answerData",answerData)
                if (protocolInfo.hasCheck) {
                    if (answerData && questionData.attributes.has_check) {
                        const isChecked = answerData.attributes.status == AnswersStatus.ACCEPTED;
                        const isNotChecked = answerData.attributes.status == AnswersStatus.OBSERVATION;
                        const isNotApplicable = answerData.attributes.status == AnswersStatus.NOT_APPLICABLE;
                        const isPending = answerData.attributes.status == AnswersStatus.PENDING;
                        const isMeasurementOnly = answerData.attributes.status == AnswersStatus.MEASUREMENT_ONLY;
                        if (isChecked) {
                            row.push(<td><Checkbox checked={true} color="primary" className='checkbox-success py-0 opacity-100' disabled/></td>)
                        } else if (isNotChecked) {
                            row.push(<td><Checkbox checked={true} color="primary" className='checkbox-error py-0 opacity-100' checkedIcon={<CancelPresentationIcon/>} disabled/></td>)
                        } else if (isNotApplicable) {
                            row.push(<td><Checkbox indeterminate={true} color="primary" className='checkbox-indeterminate py-0 opacity-100' disabled/></td>)
                        } else if (isPending) {
                            row.push(<td><div style={{paddingLeft: '12px'}}>
                                        <span class="d-flex align-items-center justify-content-center me-1" 
                                        style={{width: '20px', height: '20px', backgroundColor: '#f55000', color: 'white', borderRadius: '50%'}}>
                                        P
                                        </span>
                                    </div>
                                </td>
                            );
                        } else if (isMeasurementOnly) {
                            row.push(<td><span>-</span></td>
                            );
                        } else {
                            row.push(<td></td>);
                        }
                    } else {
                        row.push(<td></td>);
                    }
                }
                if (protocolInfo.hasMeasurement) {
                    if (answerData) {
                        let measurementText = answerData.attributes.status == AnswersStatus.NOT_APPLICABLE ? 'N.A.' : answerData.attributes.measurement;
                        const measurementNameExist = questionData.attributes.measurement_name.length;
                        if (measurementNameExist && !answerData.attributes.status == AnswersStatus.NOT_APPLICABLE) {
                            measurementText = `${questionData.attributes.measurement_name}: ${answerData.attributes.measurement}`;
                        }
                        row.push(<td>{measurementText}</td>);
                    } else {
                        row.push(<td></td>);
                    }
                }
                if (protocolInfo.hasCheck) {
                    const observation = answerData ? answerData.attributes.description : '';
                    row.push(<td>{observation}</td>);
                }
                tableRows.push(<tr>{row}</tr>);
            }
        }
        return (
            <div class="table-responsive protocoltable-container">
                <h4 class="text-center mt-4">{ this.props.protocoltableData.attributes.name }</h4>
                <table class="table table-striped">
                    <thead>
                        <tr>{ tableHeader }</tr>
                    </thead>
                    <tbody>
                        { tableRows }
                    </tbody>
                </table>  
            </div>
        );
    }
}

export default ProtocolTable;
